import React from 'react'
import trophy from './Images/trophy.jpg';
export default function About() {

  return (

    <div className="aboutus">
      <h1 className="aboutheading">ABOUT PRARAMBH</h1>
      <div className="aboutpara">
       <p>Prarambh has always been a platform to showcase talent and witness the telents
          among the students. And hence we aim to ignite your creativity by providing 
          libreal space for artists with creative fluidity which also demands confident 
          interaction with the masses. Talent is the miner that works and brings it out.  
      </p>
    </div>
    <div>
      <p  className="chairperson"> CHAIRPERSON</p>
      <p  className="chairpersonname">DEEP RAJPUT</p>
      <p  className="advisoryhead">ADVISORY HEAD</p>
      <p  className="advisoryheadname">SHUBHAM RAI</p>
      <p  className="vicechairperson"> VICE-CHAIRPERSON</p>
      <p  className="vicechairpersonname1"> JEET THAKKAR</p>
      <p  className="vicechairpersonname2"> PRIYAAL RACHN</p>
      <p  className="vicechairpersonname3"> HARSH MEHTA</p>

    </div>
    </div>
  )
}

